import React, { useEffect } from 'react';
import 'katex/dist/katex.min.css'; // шрифт KaTeX_Main — тот же Computer Modern, что в LaTeX
import cv from './cv.json';
import './CvPaper.css';

const formatDate = iso =>
  new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });

// Неподвижные бледные символы на фоне — отсылка к главной странице
const BG_SYMBOLS = ['∫', '∑', '∂', '∇', 'Ψ', 'λ', 'σ', '∞', 'ℏ', 'Ω', '∮', 'Γ', 'Δ', 'μ', '⊗', 'E'];
const bgSymbols = BG_SYMBOLS.map((s, i) => ({
  s,
  // детерминированный «разброс», чтобы фон не прыгал при перезагрузке
  left: (i * 37 + 11) % 100,
  top: (i * 53 + 7) % 100,
  rotate: (i * 47) % 360,
  size: 28 + ((i * 13) % 30),
}));

function Entry({ e }) {
  return (
    <li className="pp-entry">
      <div className="pp-row">
        <span className="pp-entry-title">
          {e.url ? (
            <a href={e.url} target="_blank" rel="noopener noreferrer">
              {e.title}
            </a>
          ) : (
            e.title
          )}
          {e.place === undefined && e.subtitle && <span className="pp-stack"> | {e.subtitle}</span>}
        </span>
        <span>{e.date}</span>
      </div>
      {e.place !== undefined && (
        <div className="pp-row pp-italic">
          <span>{e.subtitle}</span>
          <span>{e.place}</span>
        </div>
      )}
      {e.items.length > 0 && (
        <ul className="pp-items">
          {e.items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      )}
    </li>
  );
}

export default function CvPaper() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${cv.name} — CV`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <div className="pp-page">
      <div className="pp-bg" aria-hidden="true">
        {bgSymbols.map(({ s, left, top, rotate, size }, i) => (
          <span
            key={i}
            style={{ left: `${left}%`, top: `${top}%`, fontSize: size, transform: `rotate(${rotate}deg)` }}
          >
            {s}
          </span>
        ))}
      </div>

      <header className="pp-bar">
        <a href="/">← levandox</a>
        <span>% last compiled {formatDate(cv.lastUpdated)}</span>
      </header>

      <article className="pp-sheet">
        <header className="pp-head">
          {cv.photo && <img className="pp-photo" src={cv.photo} alt={cv.name} width="120" height="120" />}
          <div>
            <h1 className="pp-name">{cv.name}</h1>
            <p className="pp-italic">{cv.title}</p>
            <p>{cv.location}</p>
            <p className="pp-links">
              {cv.links.map((l, i) => (
                <React.Fragment key={l.url}>
                  {i > 0 && <span className="pp-sep"> | </span>}
                  <a
                    href={l.url}
                    {...(l.url.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                  >
                    {l.label}
                  </a>
                </React.Fragment>
              ))}
            </p>
          </div>
        </header>

        {cv.sections.map(section => (
          <section key={section.id} className="pp-section">
            <h2 className="pp-section-title">{section.title}</h2>
            {section.type === 'text' && <p className="pp-text">{section.text}</p>}
            {section.type === 'entries' && (
              <ul className="pp-entries">
                {section.entries.map((e, i) => (
                  <Entry key={i} e={e} />
                ))}
              </ul>
            )}
            {section.type === 'skills' && (
              <dl className="pp-skills">
                {section.skills.map(s => (
                  <div key={s.label}>
                    <dt>{s.label}</dt>: <dd>{s.values.join(', ')}</dd>
                  </div>
                ))}
              </dl>
            )}
          </section>
        ))}

        <footer className="pp-pagenum">1</footer>
      </article>

      {cv.pdf && (
        <p className="pp-download">
          <a href={cv.pdf} download>
            Download PDF
          </a>
        </p>
      )}
    </div>
  );
}
